import { useSubscriptionStore, useUserStore } from "@/stores";
import { getStatus } from "@/libs/Status";
import { Router, isNavigationFailure } from "vue-router";
import { decamelize } from "humps";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { allowList } from "@/config";
import { normalizeEmail, sha256Sync } from "./libs/utils";
import { reportEvent } from "@/api";
import { syncChatbase } from "@/libs/chatbase";
type PageType = "main" | "side" | "web";
const loginRouteName = "Login";
const defaultRoutePath = "/";
const Status = getStatus();
let userStore: any;
let subscriptionStore: any;
let loginStatus: any;
let userPermission: any;
let userInfo: any;
async function checkUserAuthStatus(page: PageType = "main") {
  userStore = useUserStore();
  subscriptionStore = useSubscriptionStore();
  if (!loginStatus) {
    await userStore.getCheckLogin();
    loginStatus = userStore.gettersLoginStatus;
  }
  if (
    !loginStatus?.login &&
    loginStatus?.oldUser &&
    loginStatus?.needEmailLogin
  ) {
    return isLogged(page);
  }
  if (loginStatus?.login && !userPermission) {
    await userStore.setUserPermission();
    await subscriptionStore.updateCreditCosts();
    userPermission = userStore.getUserPermission;
    if (userStore.userInfo?.email && typeof chrome.runtime === "undefined") {
      (window as any).gtag("set", "user_data", {
        email: sha256Sync(normalizeEmail(userStore.userInfo?.email)),
      });
    }
  }

  return loginStatus?.login;
}

async function isLogged(page: PageType = "main") {
  if (!userInfo) {
    await userStore.getUserProfile();
    userInfo = userStore.userInfo;
    if (userInfo) {
      // if (userInfo?.email) {
      //   (window as any).gtag('set','user_data', {
      //     email: sha256Sync(normalizeEmail(userInfo?.email)),
      //   })
      // }
      await userStore.setUserPermission();
      await subscriptionStore.updateCreditCosts();
      userPermission = userStore.getUserPermission;
    }
  }
  if (window.location.protocol === "chrome-extension:") {
    // 跳过隐私协议 & 平台授权
    // if (userPermission && userPermission.linkedinAuthorized) {
    //   await storage.set({
    //     [StorageKeyMap.AcceptPrivacyPolicy]: true,
    //     [StorageKeyMap.SkipPlatforms]: true,
    //   });
    // }

    // const accept = await storage.get([
    //   StorageKeyMap.AcceptPrivacyPolicy,
    //   StorageKeyMap.SkipPlatforms,
    // ]);
    return (
      // accept[StorageKeyMap.AcceptPrivacyPolicy] &&
      userPermission &&
      userPermission.linkedinAuthorized &&
      userPermission.googleOAuthed &&
      (userPermission.googlesheetsAuthorized ||
        userPermission.salesforceAuthorized ||
        userPermission.notionAuthorized ||
        userPermission.hubspotAuthorized ||
        userPermission.zohoAuthorized ||
        // accept[StorageKeyMap.SkipPlatforms] ||
        page === "side")
    );
  } else {
    if (page === "web") {
      return (
        userPermission &&
        userPermission.linkedinAuthorized &&
        userPermission.googleOAuthed
      );
    }
    return true;
  }
}

export function initRouterHooks(router: Router, page: PageType = "main") {
  router.beforeEach(async (to, from, next) => {
    NProgress.configure({
      showSpinner: false,
      trickle: true,
      speed: 300,
      template:
        '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner api-loading" role="spinner"><div class="spinner-icon"></div></div>',
    }); // NProgress Configuration

    if (to.path !== from.path) {
      NProgress.start();
    }
    // console.log(to.name, allowList);

    if (allowList.includes(to.name as string) && to.name !== loginRouteName) {
      // 免登录页面不检查登录状态，按匿名加载客服
      if (page === "web") {
        syncChatbase(false);
      }
      next();
    } else {
      const userLogged = await checkUserAuthStatus(page);
      Status.set("logged", userLogged);
      if (page === "web") {
        syncChatbase(!!userLogged);
      }
      if (to.name === loginRouteName) {
        if (userLogged) {
          next({ path: defaultRoutePath });
        } else {
          next();
        }
      } else if (!userLogged) {
        const currentPath = window.location.href;
        const encodedCurrentPath = encodeURIComponent(currentPath);
        next({
          name: loginRouteName,
          query: {
            logout: null,
            redirect: encodedCurrentPath,
          },
        });
      } else {
        next();
      }
    }
  });

  // 项目初始化判断
  let hasHiddenInitialLoading = false;
  const isInitialNavigation = (from: { matched?: unknown[] }) => {
    return !from?.matched || from.matched.length === 0;
  };

  router.afterEach((to, from, failure) => {
    NProgress.done();
    if (!hasHiddenInitialLoading && isInitialNavigation(from)) {
      hasHiddenInitialLoading = true;
      const loadingEl = document.getElementById("app_loading");
      if (loadingEl) loadingEl.remove();
    }
    setTimeout(() => {
      NProgress.remove();
    }, 299);
    if (isNavigationFailure(failure)) {
      // console.log("failed navigation", failure);
      return;
    }
    // console.log(to)
    document.documentElement.setAttribute(
      "data-route-name",
      decamelize(to.name as string, { separator: "-" }),
    );
    if (to.meta.track) {
      reportEvent({
        event: "show",
        target: to.meta.track as string,
      });
    }
  });
}
